export default __webpack_public_path__ + "static/media/quadro.edc9728d.jpg";